exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.number-amount[data-v-7110bff2]{\n   -webkit-transform: translateY(60px);\n           transform: translateY(60px);\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/sunpay-system-manager/src/components/welcome/index.vue"],"names":[],"mappings":";AACA;GACG,oCAAoC;WAC5B,4BAA4B;CACtC","file":"index.vue","sourcesContent":["\n.number-amount[data-v-7110bff2]{\n   -webkit-transform: translateY(60px);\n           transform: translateY(60px);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7110bff2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/welcome/index.vue
// module id = Uttv
// module chunks = 8